import { useEffect } from 'react'
import { connect } from 'react-redux'
import Faqs from 'components/FaqList/Faqs'
import { selectCurrentPhoneId } from '../App/selectors'
import { fetchFaqs } from './actions'
import { selectFaqs, selectFaqsFetching } from './selectors'

const FaqsContainer = (props) => {
  const { fetchFaqs, category, deviceId } = props
  useEffect(() => {
    fetchFaqs(category, deviceId)
  }, [])

  return <Faqs {...props} />
}

const mapStateToProps = (state) => ({
  deviceId: selectCurrentPhoneId(state),
  faqs: selectFaqs(state),
  isFetching: selectFaqsFetching(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchFaqs: (categoryId, deviceId) =>
    dispatch(fetchFaqs.request(categoryId, deviceId))
})

export default connect(mapStateToProps, mapDispatchToProps)(FaqsContainer)
